module.exports = __webpack_public_path__ + "img/error.0a38972b.png";